import { css } from '@emotion/css';

export const dropdownStyles = (charCount: number) => css`
  input {
    min-width: 8rem !important;
    width: ${charCount}ch !important;
  }
`;

export const selectInputStyles = css`
  &.MuiOutlinedInput-input {
    font-weight: 400;
    font-size: 2rem;
    line-height: 3rem;
  }
`;

export const selectOptionLabelStyles = css`
  &.heading-m {
    font-size: 2rem;
    font-weight: normal;
    line-height: 2.6rem;
  }
`;

export const submittedBlankStyles = css`
  height: 3.8rem;
  display: inline-flex;
  vertical-align: middle;
`;
